import { ParsedUrlQuery } from 'querystring';

export type ClientData = {
  fromLandmark?: string;
  fromLat?: string;
  fromLong?: string;
  fromHouse?: string;
  senderName?: string;
  senderMobile?: string;
  toLandmark?: string;
  toLat?: string;
  toLong?: string;
  toHouse?: string;
  receiverName?: string;
  receiverMobile?: string;
  vehicleId?: string;
};

export const getDefault = (): ClientData => {
  return {
    fromLandmark: undefined,
    fromLat: undefined,
    fromLong: undefined,
    fromHouse: undefined,
    senderName: undefined,
    senderMobile: undefined,
    toLandmark: undefined,
    toLat: undefined,
    toLong: undefined,
    toHouse: undefined,
    receiverName: undefined,
    receiverMobile: undefined,
    vehicleId: undefined,
  };
};

export const parsedUrlQueryToRecord = (
  query: ParsedUrlQuery,
): Record<string, string | undefined> => {
  const record: Record<string, string | undefined> = {};
  Object.keys(query).forEach(key => {
    const value = query[key];
    record[key] = Array.isArray(value) ? value[0] : value;
  });
  return record;
};

export const clientDataMapper = (
  raw_client_data: Record<string, string | undefined>,
): ClientData => {
  return {
    fromLandmark: raw_client_data['from_landmark'],
    fromLat: raw_client_data['from_lat'],
    fromLong: raw_client_data['from_long'],
    fromHouse: raw_client_data['from_house'],
    senderName: raw_client_data['sender_name'],
    senderMobile: raw_client_data['sender_mobile'],
    toLandmark: raw_client_data['to_landmark'],
    toLat: raw_client_data['to_lat'],
    toLong: raw_client_data['to_long'],
    toHouse: raw_client_data['to_house'],
    receiverName: raw_client_data['receiver_name'],
    receiverMobile: raw_client_data['receiver_mobile'],
    vehicleId: raw_client_data['vehicle_id'],
  };
};

export const isValid = (
  client_data: ClientData,
  mobile_length: number,
): boolean => {
  return (
    client_data.fromLandmark !== undefined &&
    client_data.fromLat !== undefined &&
    client_data.fromLong !== undefined &&
    client_data.senderName !== undefined &&
    client_data.senderMobile?.length === mobile_length &&
    client_data.toLandmark !== undefined &&
    client_data.toLat !== undefined &&
    client_data.toLong !== undefined &&
    client_data.receiverName !== undefined &&
    client_data.receiverMobile?.length === mobile_length &&
    client_data.vehicleId !== undefined
  );
};
